import React from 'react'

const Supports = () => {
  return (
    <div>Supports</div>
  )
}

export default Supports